(function () {
    'use strict';

    run.admin.parts.rackootEdit = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const rackoot_name_el = document.getElementById('rackoot_name');
        const rackoot_description_el = document.getElementById('rackoot_description');
        const rackoot_color_el = document.getElementById('rackoot_color');

        const sidebar_selected_rackoot = document.getElementById('rackoot_nav_item__current');

        rackoot_name_el.addEventListener('focusin', updateCharCounter);
        rackoot_description_el.addEventListener('focusin', updateCharCounter);
        rackoot_color_el.addEventListener('change', rackootSaveColor);

        rackoot_name_el.addEventListener('focusout', onContentEditableBlur);
        rackoot_description_el.addEventListener('focusout', onContentEditableBlur);

        rackoot_name_el.addEventListener('keydown', e => {
            if (e.keyCode===13) {
                rackoot_name_el.blur();
            }
        });
        rackoot_name_el.addEventListener('input', onContentEditableInput);
        rackoot_name_el.addEventListener('paste', onContentEditableInput);
        rackoot_description_el.addEventListener('input', onContentEditableInput);
        rackoot_description_el.addEventListener('paste', onContentEditableInput);

        let rackoot_data_changed = false;

        function updateCharCounter(e)
        {
            const max = e.target.dataset.maxlength;
            let count = e.target.innerText.length;

            e.target.dataset.characterCount = `${count} / ${max}`
        }

        function onContentEditableInput(e)
        {
            rackoot_data_changed = true;
            const max = e.target.dataset.maxlength;
            let count = e.target.innerText.length;
            if (count > max) {
                e.target.classList.add('invalid');
            } else {
                e.target.classList.remove('invalid');
            }

            updateCharCounter(e);
        }
        
        function onContentEditableBlur(e){
            if (rackoot_data_changed == false) {
                return;
            }

            let el = e.target;
            if (el.innerText == "\n") {
                el.innerText = el.innerText = '';
            }
            // el.innerText = el.innerText.replace(/\n/g, '<br>');
            rackootSave();
        }

        function rackootSave()
        {
            if (rackoot_name_el.classList.contains('invalid') || rackoot_description_el.classList.contains('invalid')) {
                return;
            }

            setEditableItemDisabled(rackoot_name_el);
            setEditableItemDisabled(rackoot_description_el);

            // Ajax call
            // const rackoot_tab = document.getElementById('current_rackoot_name');
            const rackoot_tab = document.getElementById('rackoot_nav_item__current').querySelector('.rackoot__name');
            const name_element = document.getElementById('rackoot_name');
            const description_element = document.getElementById('rackoot_description');

            const previous_name = rackoot_tab.innerText.trim();
            const meta_tag_element = document.querySelector('meta[name="description"]');
            const previous_description = meta_tag_element.getAttribute('content').trim();

            // New data
            let new_name = name_element.innerText.trim();
            let new_description = description_element.innerText.trim();
            new_description = new_description.replace(/\n\s*\n/g, '\n\n');
            description_element.innerHTML = new_description.replace(/\n/g, '<br>');

            rackoot_tab.innerText = new_name;
            meta_tag_element.setAttribute('content', new_description);

            // Get rackoot data
            const uuid = document.getElementById('rackoot_data').dataset.uuid;

            // Save
            var data = new FormData();
            data.append('csrf_name', csrf_name);
            data.append('csrf_value', csrf_value);
            data.append('rackoot_uuid', uuid);
            data.append('name', new_name);
            data.append('description', encodeURI(new_description));

            axios.post(GlobalRoutes.rackoots.rename, data)
            .then(function (response) {
                rackootHasSaved();
            })
            .catch(function (error) {
                rackoot_tab.innerHTML = previous_name;
                meta_tag_element.setAttribute('content', previous_description);
                name_element.innerHTML = previous_name;
                description_element.innerHTML = previous_description;
                new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
            });
        }

        function rackootHasSaved()
        {
            setEditableItemEnabled(rackoot_name_el);
            setEditableItemEnabled(rackoot_description_el);
            rackoot_data_changed = false;
        }

        function setEditableItemDisabled(element)
        {
            element.removeAttribute('contenteditable');
            element.dataset.hasContenteditable = 'true';
            element.style.opacity = .4;
        }

        function setEditableItemEnabled(element)
        {
            element.setAttribute('contenteditable', 'true');
            delete element.dataset.hasContenteditable;
            element.style.opacity = 1;
        }

        function rackootSaveColor()
        {
            const newColor = cleanHexColor(rackoot_color_el.value);
            sidebar_selected_rackoot.style.setProperty('--rackoot-color', newColor);

            var data = new FormData();
            data.append('csrf_name', csrf_name);
            data.append('csrf_value', csrf_value);
            data.append('rackoot_uuid', rackoot_data.dataset.uuid);
            data.append('color', newColor);

            axios.post(GlobalRoutes.rackoots.set_color, data)
        }
    }
})();
